import {
  Button,
  FormInput,
  FormRoot,
  FormSelect,
  RHF,
  Switch,
  zodResolver,
} from "@devhop/ui";
import { z } from "zod";
import { SHOP_CURRENCIES } from "@/shared/lib/currency";

/** Radix Select forbids value=""; use sentinel → API maps to null (inherit shop) */
export const BRANCH_CURRENCY_INHERIT = "__inherit__";

const BRANCH_CURRENCY_OPTIONS = [
  {
    value: BRANCH_CURRENCY_INHERIT,
    label: "ຕາມຮ້ານ (ໃຊ້ສະກຸນຮ້ານ)",
  },
  ...SHOP_CURRENCIES.map((c) => ({ value: c, label: c })),
];

const BranchFormSchema = z.object({
  name: z.string().min(1, "ຕ້ອງໃສ່ຊື່ສາຂາ"),
  phone: z.string().max(50).optional().nullable(),
  address: z.string().optional().nullable(),
  isActive: z.boolean(),
  defaultCurrency: z.enum(["__inherit__", "LAK", "THB", "USD"]),
});

export type BranchFormValues = z.infer<typeof BranchFormSchema>;

export function BranchForm({
  initialValues,
  onSubmit,
  submitting,
  submitLabel = "ບັນທຶກ",
}: {
  initialValues?: Partial<BranchFormValues>;
  onSubmit: (values: BranchFormValues) => void;
  submitting?: boolean;
  submitLabel?: string;
}) {
  const methods = RHF.useForm<BranchFormValues>({
    resolver: zodResolver(BranchFormSchema),
    defaultValues: {
      name: "",
      phone: "",
      address: "",
      isActive: true,
      defaultCurrency: BRANCH_CURRENCY_INHERIT,
      ...initialValues,
    },
  });

  return (
    <FormRoot<BranchFormValues>
      methods={methods}
      onSubmit={onSubmit}
      className="space-y-4"
    >
      <FormInput name="name" label="ຊື່ສາຂາ" requiredMark placeholder="ຊື່ສາຂາ" />
      <FormInput name="phone" label="ເບີໂທ" placeholder="+856 20 xxxx xxxx" />
      <FormInput name="address" label="ທີ່ຢູ່" placeholder="ບ້ານ ເມືອງ ແຂວງ" />
      <FormSelect
        name="defaultCurrency"
        label="ສະກຸນເງິນ (ບໍ່ເລືອກ = ຕາມຮ້ານ)"
        options={BRANCH_CURRENCY_OPTIONS}
      />
      <div className="flex items-center gap-2">
        <RHF.Controller
          control={methods.control}
          name="isActive"
          render={({ field }) => (
            <Switch
              id="branch-is-active"
              checked={field.value}
              onCheckedChange={field.onChange}
              className="data-[state=checked]:bg-[#F26522]"
            />
          )}
        />
        <label htmlFor="branch-is-active" className="font-medium text-sm">
          ເປີດໃຊ້ງານ
        </label>
      </div>
      <div className="flex justify-end gap-2 pt-2">
        <Button type="submit" isLoading={submitting}>
          {submitLabel}
        </Button>
      </div>
    </FormRoot>
  );
}
